import React from 'react';
import { SectionBadge } from '../SectionBadge';
import { TOMOS } from '../../data/content';
export function ProductIntro() {
  return <section className="relative w-full bg-ink-soft px-5 py-12 sm:py-16" data-id="element-190" data-mp="21i2s0g285ifw">
      <div className="mx-auto max-w-4xl text-center" data-id="element-191" data-mp="2fh2ebh29ll8w">
        <SectionBadge color="magenta" data-id="element-192" data-mp="2agwkbu8ivmnn">🔥 Megapack Zumba Pro</SectionBadge>
        <h2 className="mt-4 font-display text-3xl leading-tight text-white sm:text-5xl" data-id="element-193" data-mp="2aflkg5i76z1t">
          6 Tomos + 5 Bonos — <span className="text-lime" data-id="element-194" data-mp="2pc2umteni7ms">Todo listo para usar</span>
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-white/70 sm:text-base" data-id="element-195" data-mp="2kekqrhfhqiln">
          Planificaciones, coreografías, ritmos y crecimiento profesional, en un solo lugar.
        </p>

        <div className="mx-auto mt-7 flex max-w-md items-end justify-center gap-2 sm:gap-3" data-id="element-196" data-mp="2u66z960g23kp">
          {TOMOS.map((t, i) => <div key={t.n} className="flex flex-col items-center" style={{
          height: `${82 + i % 3 * 14}px`
        }} data-id="element-197" data-mp="382kk8p46sn3x" data-mpi={i}>
              <div className="w-9 flex-1 rounded-md shadow-lg sm:w-12" style={{
            backgroundColor: t.color,
            boxShadow: `0 8px 22px ${t.color}55`
          }} data-id="element-198" data-mp="2g5djuy3t00xs" />
              <span className="mt-1.5 text-[9px] font-bold uppercase tracking-wider text-white/50" data-id="element-199" data-mp="2l6bbs2em89ch">T{t.n}</span>
            </div>)}
        </div>
      </div>
    </section>;
}